import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d1f6721"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Filter" }
const _hoisted_2 = { class: "Content CustomScrollbar" }
const _hoisted_3 = { class: "EnterpriseTitle" }
const _hoisted_4 = { class: "Title" }
const _hoisted_5 = { class: "Subtitle" }
const _hoisted_6 = { class: "TitleWrap" }
const _hoisted_7 = {
  key: 0,
  class: "Subtitle"
}
const _hoisted_8 = { class: "UnitSelectorTitle" }
const _hoisted_9 = { class: "Heading1" }
const _hoisted_10 = { class: "UnitSelectorRadio AllUnits" }
const _hoisted_11 = { for: "AllUnits" }
const _hoisted_12 = { class: "UnitSelectorList" }
const _hoisted_13 = ["value", "id"]
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "UnitSelectorText" }
const _hoisted_16 = { class: "Heading2" }
const _hoisted_17 = {
  key: 0,
  class: "Caption"
}
const _hoisted_18 = { class: "Caption" }
const _hoisted_19 = { class: "Caption" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Spacer" }, null, -1))
const _hoisted_21 = { class: "ApplyWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterProject = _resolveComponent("FilterProject")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.projects.length > 1)
        ? (_openBlock(), _createBlock(_component_Accordion, { key: 0 }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.mixWB('PROJECTS')) + " (" + _toDisplayString(_ctx.projects.length) + ")", 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.mixWB('ENTERPRISE')) + ": " + _toDisplayString(_ctx.currentProject?.data.enterpriseID), 1)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                return (_openBlock(), _createBlock(_component_FilterProject, {
                  key: project.id,
                  project: project,
                  "is-marked": _ctx.params.projectId === project.id,
                  "is-current": _ctx.filterValues.projectId === project.id,
                  onClicked: _ctx.changeProjectID
                }, null, 8, ["project", "is-marked", "is-current", "onClicked"]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", {
                class: _normalizeClass(["Title", {'EnterpriseTitle': _ctx.isEnterpriseProject}])
              }, _toDisplayString(_ctx.mixWB('PROJECTS')) + " (" + _toDisplayString(_ctx.projects.length) + ")", 3),
              (_ctx.isEnterpriseProject)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.mixWB('ENTERPRISE')) + ": " + _toDisplayString(_ctx.currentProject?.data.enterpriseID), 1))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
              return (_openBlock(), _createBlock(_component_FilterProject, {
                key: project.id,
                disable: true,
                project: project
              }, null, 8, ["project"]))
            }), 128))
          ], 64)),
      _createVNode(_component_Accordion, { class: "UnitSelector" }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.mixWB('UNITS')), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.mixWB('SELECT_THE_UNIT_YOU_WOULD_LIKE_TO_VIEW_DATA_FOR')), 1)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.unit) = $event)),
              value: "all",
              id: "AllUnits",
              name: "unit"
            }, null, 512), [
              [_vModelRadio, _ctx.params.unit]
            ]),
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.mixWB('ALL_UNITS')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.units.active.buildings, (building) => {
              return (_openBlock(), _createElementBlock("div", {
                key: building.hashID,
                class: "UnitSelectorRadio"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.unit) = $event)),
                  value: building.hashID,
                  id: `Unit-${building.hashID}`,
                  name: "unit"
                }, null, 8, _hoisted_13), [
                  [_vModelRadio, _ctx.params.unit]
                ]),
                _createElementVNode("label", {
                  for: `Unit-${building.hashID}`
                }, [
                  _createVNode(_component_Image, {
                    image: building.getProfileImages()[0],
                    dimensions: {
                      width: 60,
                      height: 60,
                    },
                    transformation: "square_80"
                  }, null, 8, ["image"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h3", _hoisted_16, _toDisplayString(building.getFullTitle()), 1),
                    (building.getBuildingTypeCodeText())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(building.getBuildingTypeCodeText()), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(this.mixWB('BUILT_UP_AREA')) + ": " + _toDisplayString(building.getBuiltArea() ?? '-'), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(this.mixWB('YEAR_OF_CONSTRUCTION')) + ": " + _toDisplayString(building.getYearBuilt() ?? '-'), 1)
                  ])
                ], 8, _hoisted_14)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _hoisted_20,
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args))),
        class: _normalizeClass(["Apply", { 'IsDisabled': _ctx.paramsUnchanged }])
      }, _toDisplayString(_ctx.mixWB('APPLY')), 3)
    ])
  ]))
}